/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';

export const OmnisendIcon = ({
  className,
  style: styleFromProps,
  onClick,
  color = '#BAF03F',
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={className}
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="4" fill="black" />
      <path
        d="M29.7936 10.0824H14.213C13.6709 10.0816 13.1339 10.1876 12.6328 10.3945C12.1317 10.6014 11.6763 10.905 11.2927 11.2881C10.9091 11.6711 10.6047 12.126 10.3971 12.6268C10.1894 13.1276 10.0825 13.6644 10.0825 14.2065V29.7871C10.0825 30.3292 10.1894 30.866 10.3971 31.3668C10.6047 31.8676 10.9091 32.3225 11.2927 32.7055C11.6763 33.0886 12.1317 33.3922 12.6328 33.5991C13.1339 33.806 13.6709 33.912 14.213 33.9112H21.3085V30.4979C21.3085 27.2063 20.8986 24.6832 18.4524 23.9532V21.2572C22.4291 21.6158 24.4015 24.5743 24.4015 29.4349V33.9176H29.7936C30.8874 33.9176 31.9363 33.4831 32.7097 32.7097C33.4832 31.9362 33.9177 30.8873 33.9177 29.7935V14.2065C33.9177 13.1127 33.4832 12.0637 32.7097 11.2903C31.9363 10.5169 30.8874 10.0824 29.7936 10.0824ZM22.1089 18.6892C21.6565 18.6905 21.2139 18.5575 20.8371 18.307C20.4603 18.0566 20.1662 17.7 19.9922 17.2824C19.8182 16.8647 19.772 16.4049 19.8595 15.961C19.947 15.5171 20.1642 15.1091 20.4837 14.7887C20.8032 14.4684 21.2105 14.25 21.6542 14.1613C22.0978 14.0725 22.5578 14.1174 22.9759 14.2903C23.3941 14.4631 23.7515 14.7561 24.003 15.1322C24.2545 15.5083 24.3887 15.9506 24.3887 16.403C24.3887 17.0082 24.1487 17.5888 23.7214 18.0173C23.294 18.4459 22.7142 18.6875 22.1089 18.6892Z"
        fill={color}
      />
    </svg>
  );
};
